import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthService } from '@apiServices';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { RouteConstants } from '../../constants/RouteConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { FormService } from '../../services/form.service';
import {
  ModalService,
  Toast,
  UtilityService,
} from '../../services/index.service';
import { MessagingService } from '../../../shared/messaging.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  myData: any[] = [];
  adminNotification: any[] = [];
  orderNotification: any[] = [];
  adminMsgNotificaton: any[] = [];
  user: any;
  locations: { id: number; state_name: string }[] = new Array();
  subscriptions: Subscription[] = [];
  multiTenant: any = localStorage.getItem('tenant')
    ? localStorage.getItem('tenant')
    : 'pl';
  multiTenantShow: any = true;
  isDropdownDisabled: any = false;
  lodingText: any = "Switching...";
  defaultValue: any = 1;
  serverLocationSubscription: Subscription = new Subscription();
  lastServerLocationVal: number = 0;
  serverLocationVal: number = this.parseServerLocationValue(
    localStorage.getItem('serverLocation')
  );
  parentTenant = localStorage.getItem('parentTenant');
  RenewRefillCount: any;
  OrderNotificationCount: any;
  AdminCount: any;
  MessageCount: any;
  tenant: any = localStorage.getItem('tenant')

  constructor(
    public authService: AuthService,
    private messagingService: MessagingService,
    private route: ActivatedRoute,
    private router: Router,
    public formService: FormService,
    public modalService: ModalService,
    public RouteConstants: RouteConstants,
    public helperService: HelperService,
    public krollService: KRollService,
    public afAuth: AngularFireAuth,
    private toastr: ToastrService
  ) {
    this.locations = this.route.snapshot.data.appData.serverLocations;
    this.getServerLocationInitValue();
    this.setQcStatusAndLocation();
  }
  private parseServerLocationValue(value: string | null): number {
    const parsedValue = value !== null ? parseInt(value, 10) : 1;
    return isNaN(parsedValue) ? 1 : parsedValue;
  }
  setQcStatusAndLocation() {
    if (localStorage.getItem('parentTenant') == 'qc') {
      this.multiTenantShow = false;
      this.formService.setSelectedLocationVal(9);
      this.helperService.setLocalStorage('serverLocation', 9);
    }
  }
  ngOnInit(): void {
    this.getUserData();
    this.setLoginData(this.helperService.getLocalStorage('userObj'));
    // Assuming 'serverLocation' in localStorage contains a string representation of a number
    this.serverLocationVal = this.parseServerLocationValue(
      localStorage.getItem('serverLocation')
    );
    this.setQcStatusAndLocation();
    window.addEventListener('storage', (event) => {
      if (event.key === 'tenant') {
        if (event.newValue !== null) {
          this.handleTenantChange(event.newValue);
        }
      }
    });
   window.addEventListener('storage', (event) => {
      if (event.key === 'serverLocation') {
        if (event.newValue !== null) {
          setTimeout(() => {
            this.redirectNewTenant();
          }, 3000);
        }
      }
    });
  }
  handleTenantChange(newTenant: string) {
    /*  console.log('New Tenant:', newTenant);
    console.log('Current Tenant:', this.multiTenant);
   */
    if (newTenant !== this.multiTenant) {
      console.log('Reloading Page...');

      setTimeout(() => {
        this.redirectNewTenant();
      }, 1000); // 2000 milliseconds (2 seconds) delay

    } else {
      console.log('No action needed. Tenant values are the same.');
    }
  }
  onCheckChange(item: any) {
    item.updatedByUserName = this.user.display_name;
    this.messagingService.updateRenewRefill(item);
  }

  onCheckChangeAdminNotification(item: any) {
    item.updatedByUserName = this.user.display_name;
    item.updatedByUserId = this.user.id;
    this.messagingService.updateAdminNotifications(item);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  getUserData() {
    this.authService.user.subscribe((user) => {
      this.user = user?.admin;
    });
  }
  openDrawer(): void {
    UtilityService.DRAWER_REF.toggle();
  }
  getServerLocationInitValue() {
    if (this.helperService.getServerLocation() > 0) {
      this.serverLocationVal = this.helperService.getServerLocation();
      this.krollService.get_nursing_home(this.serverLocationVal);
      this.krollService.get_sales_order_status({
        server_location: this.serverLocationVal,
      });
    }
    this.serverLocationSubscription =
      this.formService.selectedLocation.valueChanges
        .pipe(distinctUntilChanged(), throttleTime(1000))
        .subscribe((val: any) => {
          this.serverLocationVal = this.helperService.getServerLocation();
          this.krollService.get_sales_order_status({ server_location: this.helperService.getServerLocation() });
          this.serverLocationSubscription.unsubscribe();
        });
  }
  serverLocationChange(ev: any) {

    this.isDropdownDisabled = true;
    let payload = { server_location: ev };
    this.lastServerLocationVal = this.formService.selectedLocation.value || 0;
    let isCreateOrderUnsaveChange: boolean = (window as any)
      .isCreateOrderUnsaveChange;

    this.helperService.setLocalStorage('serverLocation', ev);
    if (ev === 9 && localStorage.getItem('tenant') == 'ml') {
      this.changeTenant('ml_qc');
    } else if (ev != 9 && localStorage.getItem('tenant') == 'ml_qc') {
      this.changeTenant('ml');
    } else if (ev === 9 && localStorage.getItem('tenant') == 'sl') {
      this.changeTenant('qc');
    } else if (ev != 9 && localStorage.getItem('tenant') == 'qc') {
      this.changeTenant('sl');
    }else if (ev != 9 && localStorage.getItem('tenant') == 'sl') {
      this.redirectNewTenant();
    }else if (ev != 9 && localStorage.getItem('tenant') == 'pl') {
      this.redirectNewTenant();
    }
    else if (ev != 9 && localStorage.getItem('tenant') == 'wylo') {
      this.redirectNewTenant();
    }else{
      this.redirectNewTenant();
    }
  }


  reRoute(item: any, type: any) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        pageStep: '9',
        chieldPageStep: '0'
      }
    };

    if (type == 'deletion_request') {
      this.router.navigate(['/portal/users/deletion-request']);
    } else if (type == 'payment_method_add') {
      this.router.navigate(['/patient/detail/' + item], navigationExtras);
    } else {
      this.router.navigate(['/patient/detail/' + item]);
    }
  }


  changeTenant(event: any, retryCountUpdate: boolean = true) {
    this.isDropdownDisabled = true;
    this.helperService.setLocalStorage('afAuth', false);
    if (retryCountUpdate) {
      this.helperService.setLocalStorage('retryCount', 0);
    }
    this.krollService.changeTenant({ tenant: event }).subscribe(
      async (res: any) => {
        if (!res.body.success) return;
        localStorage.setItem('tenant', event);
        // if (event == 'pl' || event == 'sl' || event == 'wylo' || event == 'ml') {
        //   this.helperService.setLocalStorage('serverLocation', 1);
        // }
        const locationId = res?.body?.data?.locationId;
        if (locationId) {
          this.helperService.setLocalStorage('serverLocation', locationId);
        } else {
          this.authService.logout();
          this.toastr.error('No location assigned to the user. Please contact administrator.');
          return;
        }
        this.authService.setUser(res['body']['data']);
        setTimeout(() => this.SignOutFirebase(res.body.data), 2000);
      },
      (err) => {
        this.isDropdownDisabled = false;
        console.error(err.message);
      }
    );
  }

  setLoginData(obj: any) {

    /* Get retry count from localStorage, default to 0 if not set */
    let retryCount = parseInt(localStorage.getItem('retryCount') || '0', 10);

    /*  Login with firebase */
    if(this.helperService.getLocalStorage('afAuth')){
     // console.log('afAuth1111',this.helperService.getLocalStorage('afAuth'));
      retryCount = 0;
      localStorage.setItem('retryCount', retryCount.toString());
      this.helperService.setLocalStorage('afAuth',true);
      this.getNotification();
    }else{

      //console.log('afAuth2222',this.helperService.getLocalStorage('afAuth'));
      this.isDropdownDisabled = true;
      this.afAuth
      .signInWithCustomToken(obj.firebase_token)
      .then((res: any) => {
        /*  Local User object save */
        this.helperService.setLocalStorage('userObj', obj);
        this.authService.setUser(obj);
        /* update firebase user id */
        let user = this.helperService.getLocalStorage('userObj');
        // console.log("FirebaseID", res['user'].uid);

        user['firebaseUserId'] = res['user'].uid;
        this.helperService.setLocalStorage('userObj', user);
        this.authService.setUser(user);
        this.getNotification();
        this.helperService.setLocalStorage('afAuth',true);
        setTimeout(() => {
          this.isDropdownDisabled = false;
        },5000)

      })
      .catch((error: any) => {
        setTimeout(() => {
          this.isDropdownDisabled = false;
        },5000)
        this.helperService.setLocalStorage('afAuth',false);
        console.log('firebase error2', error);
        if (retryCount < 3) {
          retryCount++;
          localStorage.setItem('retryCount', retryCount.toString());
          this.changeTenant(this.multiTenant,false);
        } else {
            console.log('Max retry limit reached. Tenant change will not be retried.');
        }
        //window.alert(error)
      });
    }

  }

   SignOutFirebase(res: any): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        // console.log('changeTenant77', localStorage.getItem('tenant'));
        this.afAuth.signOut().then(() => {
          if (localStorage.getItem('tenant') === 'qc') {
            AngularFireModule.initializeApp(environment.firebaseQc);
          } else if (localStorage.getItem('tenant') === 'sl') {
            AngularFireModule.initializeApp(environment.firebaseSunlife);
          } else if (localStorage.getItem('tenant') === 'wylo') {
            AngularFireModule.initializeApp(environment.firebaseWylo);
          } else if (localStorage.getItem('tenant') === 'ml') {
            AngularFireModule.initializeApp(environment.firebaseTitan);
          } else if (localStorage.getItem('tenant') === 'ml_qc') {
           // console.log('changeTenant3', event);
            AngularFireModule.initializeApp(environment.firebaseTitanQc);
          }
          else if (localStorage.getItem('tenant') === 'pl_qc') {
            // console.log('changeTenant3', event);
             AngularFireModule.initializeApp(environment.firebasePlQc);
           }
          else {
            AngularFireModule.initializeApp(environment.firebase);
          }
          //console.log('changeTenant4', event);
          return this.redirectNewTenant();
        }).catch(error => {
          reject(error); // Reject the promise if there's an error during sign out
        });
      });
    }

  redirectNewTenant() {

    setTimeout(() => {
      if (localStorage.getItem('tenant') == 'sl') {
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      } else if (localStorage.getItem('tenant') == 'qc') {
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      } else if (localStorage.getItem('tenant') == 'pl') {
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      } else if (localStorage.getItem('tenant') == 'wylo') {
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      } else if (localStorage.getItem('tenant') == 'ml') {
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      } else if (localStorage.getItem('tenant') == 'ml_qc') {
        //console.log('changeTenant5');
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      } else
      {
        this.router.navigate(['/portal/dashboard'])
        setTimeout(() => {
          location.reload()
        }, 100);
      }
    }, 1000);
  }


  getNotification() {
    this.subscriptions.push(
      this.messagingService.getRenewRefillHeader().subscribe(
        (res) => {
          this.myData = [];
          for (const item of res) {
            const data = JSON.parse(JSON.stringify(item.payload.doc.data()));
            this.myData.push(data);
          }
          this.myData.sort(
            (a, b) => b.created_at.seconds - a.created_at.seconds
          );
        },
        (err) => {
          console.error(err);
        }
      )
    );
    // get admin notification

    this.subscriptions.push(
      this.messagingService
        .getAdminNotificationsForHeader()
        .subscribe((res) => {
          this.adminNotification = [];
          for (const item of res) {
            const data = JSON.parse(JSON.stringify(item.payload.doc.data()));
            this.adminNotification.push(data);
          }
          this.adminNotification.sort(
            (a, b) => b.created_at.seconds - a.created_at.seconds
          );
        })
    );

    // get messages notification
    this.subscriptions.push(
      this.messagingService.getAdminNotifyMsgForheader().subscribe((res) => {
        this.adminMsgNotificaton = [];
        for (const item of res) {
          const data = JSON.parse(JSON.stringify(item.payload.doc.data()));
          this.adminMsgNotificaton.push(data);
        }
        // this.adminMsgNotificaton.sort(
        //   (a, b) => b.created_at.seconds - a.created_at.seconds
        // );
      }, (err) => {
        console.error(err);
      })
    );

    // get order notification

    this.subscriptions.push(
      this.messagingService.getOrderNotificationHeader().subscribe(
        (res) => {
          this.orderNotification = [];
          for (const item of res) {
            const data = JSON.parse(JSON.stringify(item.payload.doc.data()));
            this.orderNotification.push(data);
          }
          this.orderNotification.sort(
            (a, b) => b.created_at.seconds - a.created_at.seconds
          );
        },
        (err) => {
          console.error(err);
        }
      )
    );


  }

  // Method to open task management modal
  async openNewTaskModal() {
    try {
      const dialogRef = await this.modalService.openTaskModal();
      if (dialogRef) {
        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            // Optional: Navigate to task management page to see the new task
            // this.router.navigateByUrl('/portal/task-management');
          }
        });
      }
    } catch (error) {
      console.error('Error opening task modal:', error);
    }
  }
  }
